import { Injectable } from '@angular/core';
import { SalesByClientsPrintingQuery, SalesByClientsPrintingQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalesByClientsPrintingQuery)
@Wrapper(SalesByClientsPrintingQueryHandlerBase)
export class SalesByClientsPrintingQueryHandler {
    public constructor(
        http: Http
    ) { }
}
